import { Link } from 'react-router-dom';
import { FileSignature } from 'lucide-react';
import { Button } from './ui/button';
import {
  CONTRACT_GATE_MESSAGE,
  CONTRACT_GATE_PATH,
  CONTRACT_GATE_TITLE,
} from '../lib/contractGate';

interface ContractGatePromptProps {
  compact?: boolean;
}

export default function ContractGatePrompt({ compact = false }: ContractGatePromptProps) {
  if (compact) {
    return (
      <div className="flex flex-wrap items-center gap-3 rounded-lg border border-amber-500/30 bg-amber-500/5 p-3">
        <FileSignature className="h-4 w-4 shrink-0 text-amber-400" />
        <p className="flex-1 text-sm text-muted-foreground">{CONTRACT_GATE_MESSAGE}</p>
        <Button asChild size="sm" variant="outline">
          <Link to={CONTRACT_GATE_PATH}>Sign agreement</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-3 rounded-lg border border-amber-500/30 bg-amber-500/5 p-4">
      <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-amber-500/10">
        <FileSignature className="h-4 w-4 text-amber-400" />
      </div>
      <div className="flex-1 space-y-2">
        <p className="text-sm font-medium">{CONTRACT_GATE_TITLE}</p>
        <p className="text-xs text-muted-foreground">{CONTRACT_GATE_MESSAGE}</p>
        <Button asChild size="sm" variant="outline">
          <Link to={CONTRACT_GATE_PATH}>Review and sign agreement</Link>
        </Button>
      </div>
    </div>
  );
}
